import { request } from '../utils/http'

export const createTravel = (payload) =>
  request('/api/travel', { method: 'POST', body: payload })

export const updateTravel = (id, payload) =>
  request(`/api/travel/${id}`, { method: 'PUT', body: payload })

export const deleteTravel = (id) =>
  request(`/api/travel/${id}`, { method: 'DELETE' })

export const getTravelList = () =>
  request('/api/travel/list')

export const getTravelStats = () =>
  request('/api/travel/stats')

export const getTravelMap = () =>
  request('/api/travel/map')
